import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, Box, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

const UpgradeCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center px-4" data-testid="upgrade-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md text-center"
      >
        <div className="flex items-center justify-center gap-2 mb-8">
          <Box className="w-8 h-8 text-blue-500" />
          <span className="text-2xl font-bold tracking-tight text-white" style={{ fontFamily: "Chivo, sans-serif" }}>
            ParamSnap
          </span>
        </div>

        <div className="bento-card p-8">
          <XCircle className="w-16 h-16 text-zinc-500 mx-auto mb-4" />
          <h2 className="text-xl font-bold text-white mb-2" style={{ fontFamily: "Chivo, sans-serif" }}>
            Upgrade Cancelled
          </h2>
          <p className="text-sm text-zinc-400 mb-6">
            No worries! Your free account is still active with 3 part generations. 
            You can upgrade anytime.
          </p>
          
          <Button
            onClick={() => navigate("/")}
            className="btn-secondary w-full flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to ParamSnap
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default UpgradeCancel;
